(function () {
  'use strict';

  angular
    .module('iqxCore')
    .controller('SettingsDevicesCtrl', SettingsDevicesCtrl)

  function SettingsDevicesCtrl($scope, serviceWorkerSvc, FormSvc, $cookies, ApiSvc, $timeout) {
    var deviceSettings = this
    let deviceOld = {}

    deviceSettings.viewTab = viewTab
    deviceSettings.reqNotifications = reqNotificationWrapper
    deviceSettings.viewDevice = viewDevice
    deviceSettings.submitNameChange = submitNameChange
    deviceSettings.closeDevice = closeDevice
    deviceSettings.activeTab = ''
    deviceSettings.devices = {}
    deviceSettings.remove = removeDevice
    deviceSettings.showBtnLoader = false
    deviceSettings.notificationsEnabled = (window.localStorage.getItem('tokenSavedOnServer') == 1)
    deviceSettings.isiOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)


    activate()

    ///////////

    function activate() {
      deviceSettings.activeTab = 'devices'
      return serviceWorkerSvc.getDevices()
        .then(function (devices) {
          deviceSettings.devices = devices
          deviceOld = angular.copy(devices)
        })
    }

    function viewDevice(deviceID) {
      document.getElementById(deviceID).getElementsByClassName('nameDisplay')[0].style.display = 'none'
      document.getElementById(deviceID).getElementsByClassName('nameEdit')[0].style.display = 'table-cell'
    }

    function closeDevice(deviceID, deviceIndex) {
      document.getElementById(deviceID).getElementsByClassName('nameDisplay')[0].style.display = 'table-cell'
      document.getElementById(deviceID).getElementsByClassName('nameEdit')[0].style.display = 'none'
      deviceSettings.devices[deviceIndex].DeviceName = deviceOld[deviceIndex].DeviceName
    }

    function submitNameChange(deviceID, deviceIndex) {
      let nameChange = deviceSettings.devices[deviceIndex].DeviceName

      return ApiSvc.exec({}, 'call/_NetPushNotificationsDeviceEdit', {
        'pDeviceID': deviceID,
        'pDeviceName': nameChange
      }, false)
        .then(activate())
    }

    function removeDevice(deviceID) {
      return serviceWorkerSvc.removeToken(deviceID)
        .then(activate())
    }

    function reqNotificationWrapper(enableOrDisable) {
      $timeout(function () {
        deviceSettings.showBtnLoader = true
      }, 100)

      return reqNotifications(enableOrDisable)
        .then(serviceWorkerSvc.getDevices())
        .then(function (devices) {
          deviceSettings.devices = devices
        })
        .then(function () {
          $timeout(function () {
            deviceSettings.showBtnLoader = false
            activate()
            FormSvc.alert(
              'Notifications' + deviceSettings.notificationsEnabled ? 'Enabled' : 'Disabled',
              deviceSettings.notificationsEnabled ? 'You will now receive push notifications.' : 'Push notifications have now been disabled.',
              'success'
            )
          }, 5000) // artificial wait to ensure that everything HAS been done (it's dodgy, but dont care!)
        })
        .catch(function () {
          deviceSettings.showBtnLoader = false
          activate()
        })
    }

    async function reqNotifications(enableOrDisable) {
      if (enableOrDisable === true) {
        if ($cookies.get('pushPermissions') !== 1) {
          return await serviceWorkerSvc.registerPush(true)
            .then(function () {
              deviceSettings.notificationsEnabled = true
            })
        } else {
          return serviceWorkerSvc.getRegToken()
            .then(function () {
              deviceSettings.notificationsEnabled = true
            })
        }
      } else { // We're turning it off!
        await serviceWorkerSvc.turnOff()
          .then(function () {
            deviceSettings.notificationsEnabled = false
          })
      }
    }

    function viewTab(tab) {
      deviceSettings.activeTab = tab
    }
  }
})()